import themes from "../../../bin/themesActions/themes.json" assert { type: "json" };

type Props = {
  theme: string;
};

export default function ThemeCssLink({ theme }: Props) {
  const themeIsValid = themes.includes(theme);

  const safeTheme = themeIsValid ? theme : "classic";

  return (
    <link
      rel="stylesheet"
      href={`/themes/${safeTheme}.css`}
      precedence="high"
    />
  );
}
